module.exports = __webpack_public_path__ + "img/noNewFriend.b374b08e.png";